import { Component, HostListener, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { navHmeUrl, navInfUrl, navOrdUrl, navQuaUrl, navRfrUrl } from './shared/routing/routing.const';

import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { spxShortcutsActions } from '@softpak/components/spx-tabs';

@Component({
    selector: 'app-shortcuts',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class AppShortcutsComponent {
  private readonly store = inject(Store);
  private readonly router = inject(Router);


  ctrlIsPressed = signal<boolean>(false);

  @HostListener('window:keyup.escape', ['$event']) escape(event: Event) {
    event.preventDefault();
    this.goToTab(0);
  }

  @HostListener('window:keyup.control.1', ['$event']) shortKey1(event: Event) {
    event.preventDefault();
    this.goToTab(1);
  }

  @HostListener('window:keyup.control.2', ['$event']) shortKey2(event: Event) {
    event.preventDefault();
    this.goToTab(2);
  }

  @HostListener('window:keyup.control.3', ['$event']) shortKey3(event: Event) {
    event.preventDefault();
    this.goToTab(3);
  }

  @HostListener('window:keyup.control.4', ['$event']) shortKey4(event: Event) {
    event.preventDefault();
    this.goToTab(4);
  }

  @HostListener('window:keyup.control.5', ['$event']) shortKey5(event: Event) {
    event.preventDefault();
    this.goToTab(5);
  }

  @HostListener('window:keyup.F1', ['$event']) shortKeyF1(event: Event) {
    event.preventDefault();
    this.goToTab(1);
  }

  @HostListener('window:keyup.F2', ['$event']) shortKeyF2(event: Event) {
    event.preventDefault();
    this.goToTab(2);
  }

  @HostListener('window:keyup.F3', ['$event']) shortKeyF3(event: Event) {
    event.preventDefault();
    this.goToTab(3);
  }

  @HostListener('window:keyup.F4', ['$event']) shortKeyF4(event: Event) {
    event.preventDefault();
    this.goToTab(4);
  }

  @HostListener('window:keydown.control', ['$event']) ctrlKeyDown(event: Event) {
    if(!this.ctrlIsPressed()) {
      this.ctrlIsPressed.set(true);
      event.preventDefault();
      this.pressCtrl(true);
    }
  }

  @HostListener('window:keyup.control', ['$event']) ctrlKeyUp(event: Event) {
    this.ctrlIsPressed.set(false);
    event.preventDefault();
    this.pressCtrl(false);
  }

  private goToTab(tab: number): void {
    switch(tab) {
      case 0: this.router.navigate([navHmeUrl]); break;
      case 1: this.router.navigate([navInfUrl]); break;
      case 2: this.router.navigate([navOrdUrl]); break;
      case 3: this.router.navigate([navQuaUrl]); break;
      case 4: this.router.navigate([navRfrUrl]); break;
    }
  }

  private pressCtrl(keyIsDown: boolean) {
    this.store.dispatch(spxShortcutsActions.ctrl({ keyIsDown }));
  }
}
